import BillReviewDetailsNew from '../../../../bills/components/discovery/BillReviewDetailsNew';

export default function SpinwheelEditReviewBillScreen() {
    return <BillReviewDetailsNew />;
}
